import { useTransition, animated } from 'react-spring';

import { CreateEventTimetable } from '@event/types';
import usePopupStore from '@popup/stores/usePopupStore';
import Button from '@ui/components/Button';
import IconSummary from '@ui/components/icons/IconSummary';

import EventTimeSlotsModal from './EventTimeSlotsModal';

export interface EventSummaryProps {
  isShown: boolean;
  timetables: CreateEventTimetable[];
  onClick: () => void;
}

const EventSummary = ({ isShown, timetables, onClick }: EventSummaryProps) => {
  const {
    popupState: { isEventTimeSlotsModalOpen },
    setPopupState,
  } = usePopupStore();

  const transition = useTransition(isShown, {
    from: { transform: 'translateY(100%) translateX(-50%)' },
    enter: { transform: 'translateY(0%) translateX(-50%)' },
    leave: { transform: 'translateY(100%) translateX(-50%)' },
  });

  return (
    <>
      {transition(
        (style, item) =>
          item && (
            <animated.div
              onClick={onClick}
              style={style}
              className="group/notificationSemi fixed bottom-0 left-1/2 z-10 flex h-[72px] w-[calc(100%-16px)] max-w-[880px] -translate-x-1/2 cursor-pointer flex-wrap items-center justify-center rounded-t-[40px] border-[1px] border-b-0 border-brand-primary-purple bg-brand-white-100 px-6 py-4 text-brand-primary-purple shadow-popup transition-colors duration-300 hover:border-brand-primary-200 hover:bg-brand-primary-200 hover:text-brand-white-100 motion-reduce:transition-none"
            >
              <IconSummary className="mr-2 fill-brand-primary-purple group-hover/notificationSemi:fill-brand-white-100" />
              Vytvořit událost
              <span className="hidden sm:inline">
                &nbsp;s&nbsp;vybranými časy
              </span>
              <div className="group/tooltip relative ml-2">
                <Button
                  onTouch={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    setPopupState({
                      isEventTimeSlotsModalOpen: !isEventTimeSlotsModalOpen,
                    });
                  }}
                  size="small"
                >
                  {timetables.length}
                </Button>
                <EventTimeSlotsModal timetables={timetables} type="tooltip" />
              </div>
            </animated.div>
          ),
      )}
      <EventTimeSlotsModal timetables={timetables} type="modal" />
    </>
  );
};

export default EventSummary;
